import { useTranslation } from "react-i18next";
import Col from "../../../components/element/col";
import Container from "../../../components/element/container";

export default function ShowroomHero() {
  const { t } = useTranslation();

  return (
    <Container className="showroom-hero">
      <Col className="_col hero-copy">
        <h1 className="_label hero-title">
          <span>{t("VISIT OUR WORKSHOPS")}</span>
          <span className="gradient-text">{t("ACROSS MALAYSIA")}</span>
        </h1>
        <p className="_label hero-subtitle">
          {t("Explore our premium workshops")}
          <br />
          {t("and meet our experts.")}
        </p>
      </Col>

    </Container>
  );
}
